import CategoriesList from './Categories-Container';

export default CategoriesList;
